var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "search-a",
    d: "M0 0L32 0 32 32 0 32z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "search-c",
    d: "M0 0L32 0 32 32 0 32z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search-a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#search-b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "search-d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#search-c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M12.0263829,22.0481682 C6.49224236,22.0481682 2.00439715,17.560323 2.00439715,12.0261824 C2.00439715,6.49003752 6.49224236,2.00419671 12.0263829,2.00419671 C17.5605234,2.00419671 22.0483686,6.49003752 22.0483686,12.0261824 C22.0483686,17.560323 17.5605234,22.0481682 12.0263829,22.0481682 M31.4269429,28.65867 L21.7938102,19.0235329 C23.2089146,17.0532105 24.0527658,14.6399163 24.0527658,12.0261824 C24.0527658,5.3836103 18.6669506,-0.000200439715 12.0263829,-0.000200439715 C5.38381073,-0.000200439715 0,5.3836103 0,12.0261824 C0,18.6667502 5.38381073,24.0525653 12.0263829,24.0525653 C14.6381124,24.0525653 17.0514065,23.2087141 19.0237333,21.7936097 L28.6588704,31.4287468 C29.4225457,32.1904177 30.6632675,32.1904177 31.4269429,31.4287468 C32.1906182,30.6630671 32.1906182,29.4243497 31.4269429,28.65867",
    mask: "url(#search-d)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.50011e29.svg";
export { ForwardRef as ReactComponent };